import axios from "axios";
import { clientVitalsAPI } from "../secrets";

export const fetchAllVideos = async () => {
    try {
        const result = await axios.get(`${clientVitalsAPI}/youtube/all-videos`);

        return result?.data?.videos;
    } catch (error) {
        throw error;
    }
}